import { Link } from "@tanstack/react-router";

import login from "@/assets/svg_icons/login.svg";
// Signups disabled 2026-07-14 — restore import + link below to re-enable.
// import signup from "@/assets/svg_icons/signup.svg";

const Header = () => {
  return (
    <header className="header-container">
      <div className="flex justify-between items-center w-full header-content gap-x-5 px-8 py-3 max-md:px-7 max-md:py-2">
        <Link
          to="/"
          className="text-[32px] max-md:text-3xl max-sm:text-2xl font-bold"
        >
          Booq
        </Link>
        <div className="flex items-center gap-x-7 max-md:gap-x-5 max-sm:gap-x-4 max-md:text-xl max-sm:text-sm">
          <Link to="/sign-in" className="flex items-center">
            <img
              src={login}
              width="20"
              height="20"
              className="mr-2 max-md:w-4 max-sm:w-3"
            />
            Log In
          </Link>
          {/* <Link to="/sign-up" className="flex items-center">
            <img
              src={signup}
              width="20"
              height="20"
              className="mr-2 max-md:w-4 max-sm:w-3"
            />
            Sign Up
          </Link> */}
        </div>
      </div>
    </header>
  );
};

export default Header;
